import React, { Dispatch, useEffect, useRef, useState } from 'react'
import { FieldLabel } from 'core/components/common/FieldLabel'
import { SketchPicker } from 'react-color'

export const FormColorPickerInput: React.FC<{
  label: string
  color: string
  setColor: Dispatch<string>
  className?: string
}> = ({ label, color, setColor, className = '' }) => {
  const [showPickerIcon, setShowPickerIcon] = useState(false)
  const pickerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!showPickerIcon) return

    const handleClickOutside = (e: MouseEvent) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target as Node)) {
        setShowPickerIcon(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showPickerIcon])
  return (
    <div className={`${className}`}>
      <FieldLabel label={label} className="label-form-color" />
      <div className="form-color-input-wrapper ">
        <div
          className="form-color-picker"
          style={{ backgroundColor: color }}
          onClick={() => setShowPickerIcon(!showPickerIcon)}
        />
        <input
          type="text"
          disabled={true}
          value={color}
          onChange={(e) => setColor(e.target.value)}
          className="form-icon-input"
        />
      </div>
      {showPickerIcon && (
        <div ref={pickerRef} className="absolute left-[120px] top-[-20px] z-20">
          <SketchPicker
            color={color}
            onChangeComplete={(color) => setColor(color.hex)}
          />
        </div>
      )}
    </div>
  )
}
